import { observer } from 'mobx-react-lite';
import { ButtonBase, Divider, IconButton, Stack, Typography } from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';
import CommentIcon from '@mui/icons-material/Comment';
import { ComponentType } from 'react';
import NonDefaultStateIndicator from 'presenters/UI/NonDefaultStateIndicator';

type PostExtraPropsT = {
  view: number;
  like: number;
  comment: number;
  // isLike: boolean; // 자기가 좋아했는지
  onClickView?: () => void;
  onClickComment?: () => void;
  showViewAction?: boolean;
  showViewCount?: boolean;
  isVisible: boolean;
  CustomActionsComponent?: ComponentType<{}>;
};

const PostExtra = observer(
  ({
    view,
    comment,
    onClickView,
    onClickComment,
    showViewAction = true,
    showViewCount = false,
    CustomActionsComponent,
  }: PostExtraPropsT) => {
    return (
      <>
        <Stack direction="row" alignItems="center" spacing={0.5} m={1}>
          {!showViewCount ? null : showViewAction && onClickView ? (
            <ButtonBase
              aria-label="읽은 사람 보기"
              onClick={onClickView}
              sx={{
                gap: 1,
                p: '5px',
                pr: 1.5,
                borderRadius: 1,
                '&:hover': { bgcolor: 'action.hover' },
                '&.Mui-focusVisible': { outline: '2px solid currentColor' },
              }}
            >
              <VisibilityIcon sx={{ color: 'action.active' }} />
              <NonDefaultStateIndicator show>
                <Typography component="span" variant="body2" textAlign="left">
                  {`${view}명 · 읽은 사람 보기`}
                </Typography>
              </NonDefaultStateIndicator>
            </ButtonBase>
          ) : (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ p: '5px', pr: 1 }}>
              <VisibilityIcon sx={{ color: 'action.active' }} />
              <Typography component="span" variant="body2" textAlign="left">
                {`${view}명`}
              </Typography>
            </Stack>
          )}
          {/* <IconButton size="small" aria-label="" onClick={onClickLike}>
            <FavoriteBorderIcon />
          </IconButton> */}
          {/* <Typography variant="body2" textAlign="left" pr={1}>
            {like}
          </Typography> */}
          <IconButton size="small" aria-label="" onClick={onClickComment}>
            <CommentIcon />
          </IconButton>
          <Typography variant="body2" textAlign="left">
            {comment}
          </Typography>

          {/* 커스텀 액션버튼 */}
          {CustomActionsComponent ? <CustomActionsComponent /> : null}
        </Stack>
        <Divider />
      </>
    );
  },
);

export default PostExtra;
